import { useQuery } from "@tanstack/react-query";
import { queueApi } from "@bw/shared/api";
import type { PartyResponse } from "@bw/shared/types/generated";
import { queryKeys } from "../../../common/query/queryClient";

/**
 * The caller's current NON-terminal party at a facility (open/queued/playing,
 * leader or member) — GET /queue/party/mine.
 *
 * Normal absence is a successful `null` response. The facility court-state stream
 * invalidates this query when another device changes the party lifecycle.
 */
export function useMyParty(facilityId: string, enabled: boolean = true) {
  return useQuery<PartyResponse | null>({
    queryKey: queryKeys.dropin.myParty(facilityId),
    queryFn: () => queueApi.getMyParty(facilityId),
    enabled: Boolean(facilityId) && enabled,
    retry: false,
    refetchOnMount: "always",
    refetchOnWindowFocus: "always",
    refetchOnReconnect: "always",
  });
}
